import { ButtonGroupNavigator } from '@/modules/applications/components/ListApplicationsTable/components/ButtonGroupNavigator';
import { UserRole } from '@/types/user';
import { PaymentPageStage } from '../../types';

const getStageLabels = (
  mainRole?: UserRole,
): Record<PaymentPageStage, string> => ({
  [PaymentPageStage.ALL]: 'All',
  [PaymentPageStage.AWAITING_PAYMENT]:
    mainRole === UserRole.EducationProvider ? 'Pending' : 'Awaiting Payment',
  [PaymentPageStage.IN_PROGRESS]:
    mainRole === UserRole.EducationProvider ? 'Scheduled' : 'In Progress',
  [PaymentPageStage.FAILED]: 'Failed',
  [PaymentPageStage.COMPLETED]: 'Completed',
});

type PaymentStagesNavigatorProps = {
  value: PaymentPageStage;
  onChange: (value: PaymentPageStage) => Promise<void>;
  countsByStage?: Record<PaymentPageStage, number>;
  isLoading?: boolean;
  className?: string;
  mainRole?: UserRole;
};

export function PaymentStagesNavigator({
  value,
  onChange,
  countsByStage,
  isLoading = false,
  className,
  mainRole,
}: PaymentStagesNavigatorProps) {
  const stageItems: PaymentPageStage[] = Object.values(PaymentPageStage);
  const stageLabels = getStageLabels(mainRole);

  const renderLabel = (stage: PaymentPageStage) => stageLabels[stage];

  return (
    <ButtonGroupNavigator<PaymentPageStage>
      value={value}
      onChange={onChange}
      items={stageItems}
      countsByItem={countsByStage}
      isLoading={isLoading}
      renderLabel={renderLabel}
      className={className}
    />
  );
}
